import type { MessageAttachmentDto } from "@multi-chat/shared";
import { cn } from "../../../lib/utils.js";
import { shouldRenderProviderAttachmentUrl } from "../attachment-media-display.js";
import { useStoredAttachmentUrl } from "../use-stored-attachment-url.js";

export function MessageReplyPreviewThumbnail({
  organizationId,
  attachment,
  className,
}: {
  organizationId: number;
  attachment: MessageAttachmentDto;
  className?: string;
}): React.JSX.Element {
  if (shouldRenderProviderAttachmentUrl(attachment) && attachment.url) {
    return (
      <img
        src={attachment.url}
        alt=""
        className={cn(
          "size-10 shrink-0 rounded-md object-cover ring-1 ring-inset ring-line/40",
          className,
        )}
      />
    );
  }

  if (attachment.storageState === "STORED") {
    return (
      <StoredReplyThumbnail
        organizationId={organizationId}
        attachment={attachment}
        className={className}
      />
    );
  }

  return (
    <div
      className={cn(
        "size-10 shrink-0 rounded-md bg-surface-muted ring-1 ring-inset ring-line/40",
        className,
      )}
      aria-hidden="true"
    />
  );
}

function StoredReplyThumbnail({
  organizationId,
  attachment,
  className,
}: {
  organizationId: number;
  attachment: MessageAttachmentDto;
  className?: string;
}): React.JSX.Element {
  const urlState = useStoredAttachmentUrl(organizationId, attachment);

  if (urlState.status !== "ready") {
    return (
      <div
        className={cn(
          "size-10 shrink-0 animate-pulse rounded-md bg-surface-muted ring-1 ring-inset ring-line/40",
          className,
        )}
        aria-hidden="true"
      />
    );
  }

  return (
    <img
      src={urlState.url}
      alt=""
      className={cn(
        "size-10 shrink-0 rounded-md object-cover ring-1 ring-inset ring-line/40",
        className,
      )}
    />
  );
}
